import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../context/auth/AuthContextProvider'
import { Box, Button, Typography } from '@mui/material'

const DriverNavBar = () => {
  const { user, userSignOut } = useAuthContext()
  const navigate = useNavigate()

  const handleLogout = () => {
    userSignOut()
    navigate('/')
  }

  return (
    <Box
      sx={{
        alignItems: 'center',
        borderBottom: '1px solid var(--mercury)',
        display: 'flex',
        gap: 2,
        justifyContent: 'space-between',
        py: 2,
      }}
    >
      <Box>
        <Typography variant="h6">{user.name}</Typography>
        <Typography>
          {user.companyName.length > 0
            ? user.companyName
            : user.organisationName}
        </Typography>
      </Box>
      <Button variant="contained" color="error" onClick={handleLogout}>
        Sign Out
      </Button>
    </Box>
  )
}

export default DriverNavBar
